import { observer } from 'mobx-react';
import CustomTooltip, { TOOLTIP_POSITION, TOOLTIP_TYPE } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import { Icons } from '~/assets/fonts/Icons/icons';
import { localeStore } from '~/mobx/localesStore';
import Icon from '~/view/components/Controls/Icon/Icon';
import { IPickerOption } from '~/view/components/Controls/Pickers/Picker/types';
import './style.scss';

interface IProps {
  selectedToYouBranch: IPickerOption;
}

const ToYouDisabledPicker: React.FC<IProps> = observer(({ selectedToYouBranch }) => {
  return (
    <div className="to-you-selected-branch">
      <div className="to-you-selected-branch-text">{selectedToYouBranch?.label}</div>
      <CustomTooltip
        position={TOOLTIP_POSITION.PORTAL}
        type={TOOLTIP_TYPE.INFO}
        message={localeStore.t('branch_matching_unavailable_infotip')}
        wrapperClassName="to-you-selected-branch-tooltip"
      >
        <Icon name={Icons.Info} size={20} className="cursor-pointer color-gray2" />
      </CustomTooltip>
    </div>
  );
});

export default ToYouDisabledPicker;
